module.exports = __webpack_public_path__ + "static/media/copy-code-google.3b9be2e4.mp4";